import { httpservice, httpserviceWithMultipart } from '../services';
import { constants } from '../constant/constant';
import { dateFormat } from '../helper/StringUtils';

const apiEndPoint = constants.ADMIN_URL;

/**
 * get license templates
 * @returns {return license templates}
 */
export const getGeneratedLicenses = (obj) => (dispatch) => {
  let query;
  if (!obj) {
    query = `${constants.API.GET_LICENSES}`;
  } else if (obj.clientId) {
    query = `${constants.API.GET_LICENSES}/${obj.clientId}`;
  } else {
    query = `${constants.API.GET_LICENSES}?page=${obj.page}&size=${obj.size}`;
  }
  dispatch({
    payload: [],
    type: 'GET_GENERATED_LICENSES_REQUEST_INITIATED',
  });

  return httpservice()
    .get(query)
    .then((licenseResponse) => {
      const rows = licenseResponse.data.response.data.licenses;

      const count = licenseResponse.data.response.data.totalItems;
      const filteredData = rows.filter((data) => data.forClient && data.forSoftware);

      const finalData = filteredData.map((data) => (
        {
          ...data,
          softwareName: data.forSoftware ? data.forSoftware.name : 'N/A',
          softwareCode: data.forSoftware ? data.forSoftware.code : 'N/A',
          activationStatus: `${data.licenseInstance.length}/${data.instanceLimit}`,
          created_at: dateFormat(data.createdAt),
          expiryDate: dateFormat(data.expiryDate),
        }
      ));

      dispatch({
        payload: {
          data: finalData,
          count,
        },
        type: 'GET_GENERATED_LICENSES_REQUEST_SUCCESS',
      });

      return finalData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: 'GET_GENERATED_LICENSES_REQUEST_ERROR',
      });
    });
};

export const getGeneratedLicense = (id) => (dispatch) => {
  const query = `${constants.API.LICENSE_GENERATE}/${id}`;
  dispatch({
    payload: [],
    type: 'GET_LICENSE_REQUEST_INITIATED',
  });

  return httpservice()
    .get(query)
    .then((licenseData) => {
      dispatch({
        payload: { data: licenseData.data },
        type: 'GET_LICENSE_REQUEST_SUCCESS',
      });
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: 'GET_LICENSE_REQUEST_ERROR',
      });
    });
};

export const createLicense = (postData) => httpservice()
  .post(constants.API.LICENSE_GENERATE, postData)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const updateLicense = (updateData) => httpservice()
  .put(`${constants.API.LICENSE_GENERATE}`, updateData)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const offlineLicense = (licenseData) => httpservice()
  .post(`${constants.API.GET_OFFLINE_LICENSES}`, licenseData)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const deleteLicense = (id) => httpservice()
  .delete(`${constants.API.LICENSE_GENERATE}?id=${id}`)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const uploadLicense = (licenseData) => httpserviceWithMultipart('post', licenseData, `${apiEndPoint}${constants.API.LICENSE_UPLOAD}`)
  .then((response) => response.data)
  .catch((error) => error.response.data);
